import axios from '@/shared/axios';
import {
  InsHashTagModel,
  InsHashTagSearchModel,
  InstagramAnonymouslyModel,
  InstagramHighlightsDetailModel,
  InstagramPostsCommentsModel,
  InstagramPostsLikesModel,
  InstagramQueryPostsModel,
  InstagramStoriesDetailModel,
} from '@/types/anonymously.interface';
import { SearchLimitLeftModel } from '@/types/home';
import { BaseResponse } from '@/types/web.interface';

export async function fetchInstagramAnonymouslySearchData(media_name?: any, locale?: string) {
  const res = await axios.get<BaseResponse<InstagramAnonymouslyModel>>(`/ins/story/story/search`, {
    params: {
      media_name,
    },
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

export async function fetchInstagramAnonymouslyDemoData(media_name?: any, locale?: string) {
  const res = await axios.get<BaseResponse<InstagramAnonymouslyModel>>(`/ins/story/story/demo`, {
    params: {
      media_name,
    },
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

export async function fetchInstagramAnonymouslyTimesData(locale?: string) {
  const res = await axios.get<BaseResponse<SearchLimitLeftModel>>(`/ins/story/search/left`, {
    headers: {
      'Current-Language': locale,
    },
  });
  return res.data;
}

export async function fetchInstagramAnonymouslyStoryDetailData(storyId?: any, locale?: string) {
  const res = await axios.get<BaseResponse<InstagramStoriesDetailModel>>(
    `/ins/story/detail/${storyId}`,
    {
      params: {
        storyId,
      },
      headers: {
        'Current-Language': locale,
      },
    },
  );
  return res.data;
}

export async function fetchInstagramAnonymouslyHighlightsDetailData(
  highlightsId?: any,
  locale?: string,
) {
  const res = await axios.get<BaseResponse<InstagramHighlightsDetailModel>>(
    `/ins/story/highlights/detail/${highlightsId}`,
    {
      params: {
        highlightsId,
      },
      headers: {
        'Current-Language': locale,
      },
    },
  );

  return res.data;
}

// 查询帖子数据
export async function fetchInsFamousQueryPostsData(media_name: any, page_token?: string) {
  const res = await axios.post<BaseResponse<InstagramQueryPostsModel>>(`/ins/famous/query/posts`, {
    media_name,
    page_token,
  });
  return res.data;
}

// 获取帖子评论数据
export async function fetchInsFamousPostCommentsData(code: string, pagination_token?: string) {
  const res = await axios.get<BaseResponse<InstagramPostsCommentsModel>>(
    `/ins/famous/post/comments/${code}`,
    {
      params: {
        pagination_token,
      },
    },
  );
  return res.data;
}

// 获取帖子点赞数据（无分页）
export async function fetchInsFamousPostLikesData(code: string) {
  const res = await axios.get<BaseResponse<InstagramPostsLikesModel>>(
    `/ins/famous/post/like/${code}`,
  );
  return res.data;
}

// 用户需求收集，暂时没有额外参数，仅是针对帖子评论查看更多评论这个需求点
export async function sendInsFamousRequireAddRequest() {
  const res = await axios.post<BaseResponse<undefined>>(`/ins/famous/require/add`);
  return res.data;
}

export async function fetchInsHashtagListData() {
  const res = await axios.get<BaseResponse<[InsHashTagModel]>>(`/ins/hashtag`);
  return res.data;
}

export async function searchInsHashtagListData(keyword?: string) {
  const res = await axios.get<BaseResponse<[InsHashTagSearchModel]>>(`/ins/hashtag/search`, {
    params: {
      keyword,
    },
  });
  return res.data;
}
